import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80fe9b80"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "line--only",
  style: {"width":"60px","line-height":"20px"}
}

import { ref, computed, watch, Ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { bury } from '@/util/useBury'
import { useSite2Station, useSite, isJA } from '@/store'
import { Site } from '@/common/const'
import { useRoute } from 'vue-router'
interface S {
  label: string;
  value: string;
  channel: number | string | never;
}

interface C {
  cateNameJp: string;
  cateNameKr?: string;
  cateNameEn?: string;
  productCategoryFrontendId: string | number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const stationCode = useSite2Station()
const rotate1 = ref(false)
const rotate2 = ref(false)

const pop = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, 5]
      }
    }
  ]
}
const clickSeller = (v) => {
  store.commit('bussiness/platformType', v.value)
  bury('ALL_Click_ChannelChose1', v.label)
}

const store = useStore()

const buss = store.state.bussiness
const Sellers = computed(() => {
  let SellersList = []
  SellersList = buss.Sellers.map((i: S) => {
    if (i.value !== 'AM') {
      return i
    } else {
      return { ...i, label: isJA() ? t('1688国家货盘') : t('1688严选') }
    }
  })
  if (buss.schannel === '0' || buss.schannel === '2' || buss.schannel === '') {
    // 我的频道搜索与透明购一致
    return SellersList
  } else {
    return SellersList.filter(
      (v: S) => buss.schannel ? (!v.channel || v.channel === buss.schannel) : true
    )
  }
})
console.log(Sellers, 'Sellers')

const seller = ref({})

watch(() => buss.platformType, () => {
  seller.value = Sellers.value.find((v: S) => v.value === buss.platformType) || {}
}, { immediate: true })

const cates: Ref<C[]> = ref([
  {
    cateNameJp: t('类目'),
    productCategoryFrontendId: ''
  }
])
const schannel = computed(() => buss.schannel)
const cate = computed(() =>
  cates.value?.find(
    (v) => v.productCategoryFrontendId === buss.productCategoryFrontendId
  )
)

buss.promise.then(() => {
  console.log(buss.category, 'buss.category')

  cates.value = buss.category[buss.schannel || '0']
  store.commit('bussiness/productCategoryFrontendId', '')
  watch(schannel, (v) => {
    cates.value = buss.category[v || '0']
    store.commit('bussiness/productCategoryFrontendId', '')
    store.commit('bussiness/platformType', '')
    store.commit('bussiness/seller', '')
  })
})

const changeCate = (v: any) => {
  store.commit(
    'bussiness/productCategoryFrontendId',
    v.productCategoryFrontendId
  )
  store.commit(
    'bussiness/productCategoryFrontendIdNameZh',
    v.cateNameZh
  )
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rel custom-plain", _unref(useSite)()])
  }, [
    _createVNode(_component_el_dropdown, {
      class: _normalizeClass(_unref(isJA)() ? 'dropdown_categroy' : ''),
      "popper-options": pop,
      placement: "bottom-start",
      onVisibleChange: _cache[0] || (_cache[0] = e => rotate1.value = e)
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, { class: "seller-menu" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Sellers), (v) => {
              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: v.value,
                class: "drop-item",
                onClick: ($event: any) => (clickSeller(v))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(v.label)), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_unref(buss).platformType === 'AM')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: `https://static-s.theckb.com/BusinessMarket/icon/1688selected/home-selected-tips-${_unref(useSite)()}.png`,
              alt: "",
              class: _normalizeClass(["regularTagImg", _unref(useSite)()])
            }, null, 10, _hoisted_1))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "default",
          class: "xl-btn lf-btn v-line"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(seller.value ? seller.value.label : '') + " ", 1),
            _createElementVNode("i", {
              class: "fa fa-caret-down",
              style: _normalizeStyle({ transform: `scaleY(${rotate1.value ? -1 : 1})` })
            }, null, 4)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_el_dropdown, {
      "popper-options": pop,
      placement: "bottom-start",
      onVisibleChange: _cache[1] || (_cache[1] = (e) => (rotate2.value = e))
    }, {
      dropdown: _withCtx(() => [
        (!cates.value?.length)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              "image-size": 100
            }))
          : (_openBlock(), _createBlock(_component_el_dropdown_menu, {
              key: 1,
              class: "cate-menu"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cates.value, (v) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: v.productCategoryFrontendId,
                    onClick: ($event: any) => {{
            changeCate(v);
            _unref(bury)('ALL_Click_CategoryChose1', {
              [_unref(Site).JA]: v.cateNameJp,
              [_unref(Site).KO]: v!.cateNameKr,
              [_unref(Site).EN]: v!.cateNameEn,
            }[_unref(stationCode)] as string);
          }
            },
                    class: "drop-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString({
                [_unref(Site).JA]: v.cateNameJp,

                [_unref(Site).KO]: v!.cateNameKr,
                [_unref(Site).EN]: v!.cateNameEn,
              }[_unref(stationCode)]), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "default",
          class: "xl-btn rt-btn"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString({
            [_unref(Site).JA]: _unref(cate)?.cateNameJp,
            [_unref(Site).KO]: _unref(cate)?.cateNameKr,
            [_unref(Site).EN]: _unref(cate)?.cateNameEn,
          }[_unref(stationCode)] || _unref(cate)?.cateNameJp), 1),
            _createElementVNode("i", {
              class: "fa fa-caret-down",
              style: _normalizeStyle({ transform: `scaleY(${rotate2.value ? -1 : 1})` })
            }, null, 4)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}
}

})